/**
 * AddonHorizontalCard component.
 */
import Addon from '@shared/classes/addon';
import Card from '@shared/types/props/card';
import Container from '@components/atoms/container/tickAddonContainer';
import Tick from '@components/atoms/icons/tick';
import HorizontalCard from './horizontalCard';

export default function AddonHorizontalCard({
  item,
  index,
  onClick,
  releaseAction,
}: Card) {
  const checkAddon = (item as Addon).checkAddon && (item as Addon).checkAddon();
  return (
    <HorizontalCard
      key={index}
      index={index}
      item={item}
      showInfo={false}
      showMask={false}
      onClick={onClick}
      releaseAction={releaseAction}
    >
      {checkAddon ? (
        <Container>
          <Tick />
        </Container>
      ) : (
        <></>
      )}
    </HorizontalCard>
  );
}
